import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface WhatsAppPreviewProps {
  mensaje: string
}

export function WhatsAppPreview({ mensaje }: WhatsAppPreviewProps) {
  return (
    <Card className="border border-gray-300 dark:border-gray-700 sticky top-5">
      <CardHeader className="border-b border-gray-300 dark:border-gray-700">
        <CardTitle className="text-base">Vista Previa</CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="rounded-lg p-4 min-h-[200px] whitespace-pre-wrap font-sans bg-[#e5ddd5] dark:bg-[hsl(220,15%,14%)] text-gray-900 dark:text-gray-200"
          style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
        >
          {mensaje || 'Escribe un mensaje...'}
        </div>
      </CardContent>
    </Card>
  )
}
